import { render, staticRenderFns } from "./TireReferenceModelView.vue?vue&type=template&id=b485c690&"
import script from "./TireReferenceModelView.vue?vue&type=script&lang=js&"
export * from "./TireReferenceModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports